import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useEffect, useMemo, useState } from "react"
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaEdit,
  FaPlus,
} from "react-icons/fa"
import { MdDelete } from "react-icons/md"
import {
  Card,
  CardBody,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap"
import Swal from "sweetalert2"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"

const OtherLocation = () => {
  const [locations, setLocations] = useState([
    // Sample initial data
    {
      id: 1,
      name: "Location A",
      address: "df saf asdf asf asfd asfd asdf",
    },
    {
      id: 2,
      name: "Location B",
      address: "jsd fjskadf akjfb akfd asf. asdfa f",
    },
  ])
  const [loading, setLoading] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [modal, setModal] = useState(false)
  const [currentLocation, setCurrentLocation] = useState({
    id: null,
    name: "",
    address: "",
  })

  const [perPageItem, setPerPageItem] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    fetchLocations()
  }, [])

  async function fetchLocations() {
    const APIdata = await fetchData(setLoading, "location/fetch/others")
    if (APIdata?.success) {
      setLocations(APIdata?.data?.reverse())
    } else {
      setLocations(false)
      Swal.fire(
        "Something Went Wrong",
        APIdata?.response?.data?.message,
        "error"
      )
    }
  }

  const toggleModal = () => setModal(!modal)

  const handleInputChange = e => {
    const { name, value } = e.target
    setCurrentLocation({ ...currentLocation, [name]: value })
  }

  const handleAddEditLocation = async () => {
    if (!currentLocation.name.trim() || !currentLocation.address.trim()) {
      Swal.fire(
        "Validation Error",
        "Location Name and Address are required.",
        "warning"
      )
      return
    }
    if (currentLocation.id) {
      const APIdata = await FetchPutData(
        setLoading,
        "location",
        currentLocation?.id,
        currentLocation
      )
      if (APIdata?.data?.success) {
        Swal.fire(
          "Location Upadated Successfully.",
          APIdata?.data?.message,
          "success"
        )
        fetchLocations()
      } else {
        Swal.fire(
          "Something Went Wrong",
          APIdata?.response?.data?.message,
          "error"
        )
      }
    } else {
      const APIdata = await FetchPostData(
        setLoading,
        "location/add/others",
        currentLocation
      )
      if (APIdata?.data?.success) {
        Swal.fire(
          "Location Added Successfully.",
          APIdata?.data?.message,
          "success"
        )
        fetchLocations()
      } else {
        Swal.fire(
          "Something Went Wrong",
          APIdata?.response?.data?.message,
          "error"
        )
      }
    }
    setCurrentLocation({
      id: null,
      name: "",
      address: "",
    })
    toggleModal()
  }

  const handleDeleteLocation = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIdata = await FetchDeleteData(setLoading, "location", id)
        if (APIdata?.data?.success) {
          Swal.fire(
            "Location Deleted Successfully.",
            APIdata?.data?.message,
            "success"
          )
          fetchLocations()
        } else {
          Swal.fire(
            "Something Went Wrong",
            APIdata?.response?.data?.message,
            "error"
          )
        }
      }
    })
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const filteredLocations = locations.filter(
    location =>
      location?.name?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      location?.address?.toLowerCase().includes(searchTerm?.toLowerCase())
  )

  const totalPages = Math.ceil(filteredLocations.length / perPageItem)

  const paginatedLocations = useMemo(() => {
    const start = (currentPage - 1) * perPageItem
    return filteredLocations.slice(start, start + perPageItem)
  }, [filteredLocations, currentPage, perPageItem])

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Breadcrumb
        title="Dashboard"
        breadcrumbItem="Other Locations"
        description="Manage Other Location Details From Here"
      />

      <Card>
        <CardBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-3 align-items-center">
              <Input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={handleSearchChange}
                className=" w-auto"
              />
              <select
                className="form-select rounded-4 ps-3 pe-5 w-auto"
                value={perPageItem}
                onChange={e => {
                  setPerPageItem(Number(e.target.value))
                  setCurrentPage(1)
                }}
              >
                <option value={10}>Show 10</option>
                <option value={20}>Show 20</option>
                <option value={50}>Show 50</option>
              </select>
            </div>
            <Button
              color="primary"
              onClick={() => {
                setCurrentLocation({
                  id: null,
                  name: "",
                  address: "",
                })
                toggleModal()
              }}
              className=""
            >
              <FaPlus /> Add Location
            </Button>
          </div>

          <Table>
            <thead className="bg-blue">
              <tr>
                <th>#</th>
                <th>Location Name</th>
                <th>Location Address</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedLocations.map((location, index) => (
                <tr key={location.id}>
                  <td> {(currentPage - 1) * perPageItem + index + 1}</td>
                  <td>{location.name}</td>
                  <td>{location.address}</td>
                  <td>
                    <Button
                      color="warning"
                      onClick={() => {
                        setCurrentLocation(location)
                        toggleModal()
                      }}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      color="danger"
                      onClick={() => handleDeleteLocation(location.id)}
                      className="ms-2"
                    >
                      <MdDelete />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-between  gap-2">
            <p className="mb-0">
              Showing {paginatedLocations.length} out of {locations.length}{" "}
              Other Locations.
            </p>
            <div>
              <Button
                size="sm"
                disabled={currentPage === 1}
                className="fs-6"
                onClick={() => setCurrentPage(prev => prev - 1)}
              >
                <FaChevronCircleLeft />
              </Button>
              {Array.from({ length: totalPages }, (_, i) => (
                <Button
                  key={i}
                  size="sm"
                  className="mx-2 fs-6"
                  color={currentPage === i + 1 ? "primary" : "light"}
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </Button>
              ))}
              <Button
                size="sm"
                className="fs-6"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(prev => prev + 1)}
              >
                <FaChevronCircleRight />
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      {/* Modal for Add/Edit */}
      <Modal isOpen={modal} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>
          {currentLocation.id ? "Edit Location" : "Add Location"}
        </ModalHeader>
        <ModalBody>
          <Label>Location Name</Label>
          <Input
            type="text"
            name="name"
            value={currentLocation.name}
            onChange={handleInputChange}
            placeholder="Location Name"
            className="mb-2"
          />
          <Label className="mt-4">Location Address</Label>
          <textarea
            type="text"
            name="address"
            value={currentLocation.address}
            onChange={handleInputChange}
            placeholder="Address"
            className="mb-2 rounded-4 form-control"
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAddEditLocation}>
            {currentLocation.id ? "Update" : "Add"}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}

export default OtherLocation
